// extracted by mini-css-extract-plugin
export default {"add":"ChangeRate_add__DmYHi","subtract":"ChangeRate_subtract__WbTNK"};